import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { hasPermission, permissionConfig } from "_helpers/permissions";
import { history } from '_helpers';

export { PrivateRoute };

function PrivateRoute() {
    const auth = useSelector(x => x.auth.value);
    const adminAccess = hasPermission(permissionConfig.adminAccess);
    const currentPath = history.location.pathname;
    if (!auth) {
        // not logged in so redirect to login page with the return url
        return <Navigate to="/account/login" state={{ from: history.location }} />
    }
   
    if (currentPath.startsWith('/admin-') && !adminAccess) {
        // no admin access so redirect to home page
        return <Navigate to="/" />;
    }

    // authorized so return outlet for child routes
    return <Outlet />;
}